import React from "react";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

type BaseProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  id?: string;
  label?: string;
  required?: boolean;
  error?: string;
  className?: string;
  textareaClassName?: string;
};

type WithRegister = BaseProps & {
  name: string;
  register: (name: any) => any;
};

type WithoutRegister = BaseProps & {
  name?: string;
  register?: never;
};

type Props = WithRegister | WithoutRegister;

const TextAreaField: React.FC<Props> = ({
  id,
  label,
  required,
  error,
  className,
  textareaClassName,
  register,
  name,
  ...rest
}) => {
  const textareaProps =
    register && name ? { ...(register(name) as object) } : {};

  return (
    <div className={className}>
      {label && (
        <Label htmlFor={id || name}>
          {label} {required ? "*" : null}
        </Label>
      )}
      <Textarea
        id={id || name}
        aria-invalid={!!error}
        className={cn("mt-1", textareaClassName)}
        {...textareaProps}
        {...rest}
      />
      {error && <p className="text-destructive mt-1 text-sm">{error}</p>}
    </div>
  );
};

export default TextAreaField;
